import PropTypes from 'prop-types';
import classNames from 'classnames';
import { alpha, makeStyles } from '@material-ui/core';
import UserAvatar from '../../userAvatar';
import ToggleComponent from '../../toggleComponent';
import ActionButton from '../../actionButton';
import { ACTION_BUTTON_TYPES } from '../../actionButton/config';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    backgroundColor: primary.bluish9,
    boxSizing: 'border-box',
    border: `1px solid ${primary.bluish9}`,
    borderRadius: 8,
    display: 'grid',
    gridTemplateColumns: '1fr fit-content(0)',
    gap: 8,
    alignItems: 'center',
    padding: spacing(2, 2.75, 2, 4),
    height: 50,
    opacity: 1,
    transition:
      'border-color .3s ease, opacity .3s ease, background-color .3s ease',
  },
  excluded: {
    backgroundColor: alpha(primary.bluish9, 0.5),
    borderColor: primary.red3,
  },
  avatar: {
    transition: 'opacity .3s ease',
  },
  avatarExcluded: {
    opacity: 0.5,
  },
  avatarCaption: {
    transition: 'color .3s ease',
  },
  avatarCaptionExcluded: {
    color: alpha(primary.bluish1, 0.5),
  },
  button: {
    width: 24,
    height: 24,
  },
  icon: {
    height: 16,
    width: 16,
  },
  disabled: {
    opacity: 0.5,
  },
}));

const StepParticipant = ({
  translations,
  participant,
  isDisabled,
  onToggleExclude,
}) => {
  const classes = useStyles();

  const handleToggleUser = () => onToggleExclude(!participant.isExcluded);

  return (
    <div
      className={classNames(classes.root, {
        [classes.excluded]: participant.isExcluded && !isDisabled,
        [classes.disabled]: isDisabled,
      })}
    >
      <UserAvatar
        labelClass={classNames(classes.avatarCaption, {
          [classes.avatarCaptionExcluded]:
            participant.isExcluded && !isDisabled,
        })}
        customAvatarClass={classNames(classes.avatar, {
          [classes.avatarExcluded]: participant.isExcluded && !isDisabled,
        })}
        variant="subtitle1"
        user={participant}
        caption
      />
      <ToggleComponent inKey={!participant.isExcluded}>
        {participant.isExcluded || isDisabled ? (
          <ActionButton
            className={classes.button}
            iconButtonClass={classes.button}
            iconClass={classes.icon}
            type={ACTION_BUTTON_TYPES.UPLOAD}
            tooltipText={translations.includeUser}
            isDisabled={isDisabled}
            onClickHandler={handleToggleUser}
          />
        ) : (
          <ActionButton
            className={classes.button}
            iconButtonClass={classes.button}
            iconClass={classes.icon}
            type={ACTION_BUTTON_TYPES.CLOSE}
            tooltipText={translations.excludeUser}
            isDisabled={isDisabled}
            onClickHandler={handleToggleUser}
          />
        )}
      </ToggleComponent>
    </div>
  );
};

StepParticipant.propTypes = {
  translations: PropTypes.object.isRequired,
  participant: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onToggleExclude: PropTypes.func.isRequired,
};

export default StepParticipant;
